webpackJsonp([29],{

/***/ 1522:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__ = __webpack_require__(1862);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "context", function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebbd7d22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__ = __webpack_require__(2187);
function injectStyle (ssrContext) {
  __webpack_require__(2183)
  __webpack_require__(2185)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ebbd7d22"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Faq_vue__["b" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ebbd7d22_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Faq_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Otwarte modale w kolejności otwierania. Esc zamyka tylko ostatni, żeby przy
// zagnieżdżonych modalach (np. wykres otwierany z modala szczegółów alarmów)
// nie zamykały się wszystkie naraz.
var openModals = [];

// Esc w otwartej liście vue-select / vue-multiselect zamyka samą listę; przy
// otwartym kalendarzu vue2-datepicker też nie ruszamy modala, żeby jednym
// klawiszem nie stracić wypełnionego formularza.
var OPEN_DROPDOWN = '.vs--open, .multiselect--active';
var OPEN_DATEPICKER = '.mx-datepicker-popup';

// Faza capture: sprawdzamy listy, zanim ich własna obsługa Esc je zamknie.
function onDocumentKeydown(event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;

    var topModal = openModals[openModals.length - 1];
    if (topModal == null) return;

    var target = event.target;
    if (target instanceof Element && target.closest(OPEN_DROPDOWN) != null) return;
    if (document.querySelector(OPEN_DATEPICKER) != null) return;

    topModal.$emit('close');
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: {
            immediate: true,
            handler: function handler(isOpen) {
                isOpen ? this.registerOpen() : this.unregisterOpen();
            }
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unregisterOpen();
    },

    computed: {
        style: function style() {
            return 'max-width: ' + this.maxWidth;
        }
    },
    methods: {
        registerOpen: function registerOpen() {
            if (openModals.includes(this)) return;
            openModals.push(this);
            if (openModals.length === 1) {
                document.addEventListener('keydown', onDocumentKeydown, true);
            }
        },
        unregisterOpen: function unregisterOpen() {
            var index = openModals.indexOf(this);
            if (index === -1) return;
            openModals.splice(index, 1);
            if (openModals.length === 0) {
                document.removeEventListener('keydown', onDocumentKeydown, true);
            }
        }
    }
});

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__(1545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__(1550);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-330662f6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330662f6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1548:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1549);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("6de141c4", content, true, {});

/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".modal[data-v-330662f6]{position:fixed;z-index:110;left:0;top:0;width:100%;height:100%;overflow:auto;display:block;background-color:rgba(0,0,0,.4)}.flex-container[data-v-330662f6]{height:100%;padding:0;margin:0;display:-webkit-box;display:-ms-flexbox;display:flex}.modal-content[data-v-330662f6]{margin:auto;background-color:#fefefe;border:unset;width:auto;z-index:1000;border-radius:5px;-webkit-box-shadow:0 4px 10px rgba(0,0,0,.2);box-shadow:0 4px 10px rgba(0,0,0,.2)}.modal-header[data-v-330662f6]{background-color:#34758e;width:100%;font-family:SourceSansProBold,sans-serif;font-size:16px;font-style:normal;font-weight:600;color:#fff}.close[data-v-330662f6]{color:#fff;float:right;font-size:28px;font-weight:700}.close[data-v-330662f6]:focus,.close[data-v-330662f6]:hover{color:#000;text-decoration:none;cursor:pointer}.widthClass[data-v-330662f6]{max-width:30%}#mdiv[data-v-330662f6]{width:25px;height:25px;cursor:pointer}.mdiv[data-v-330662f6]{height:25px;width:2px;margin-left:12px;background-color:#fff;-webkit-transform:rotate(45deg);transform:rotate(45deg);Z-index:1}.md[data-v-330662f6]{height:25px;width:2px;background-color:#fff;-webkit-transform:rotate(90deg);transform:rotate(90deg);Z-index:2}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/components/Modal.vue"],"names":[],"mappings":"AACA,wBACI,eAAgB,AAGhB,YAAa,AACb,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,YAAa,AACb,cAAe,AACf,cAAe,AACf,+BAAkC,CACrC,AACD,iCACI,YAAa,AACb,UAAW,AACX,SAAU,AACV,oBAAqB,AACrB,oBAAqB,AACrB,YAAc,CACjB,AAKD,gCACI,YAAa,AACb,yBAA0B,AAC1B,aAAc,AACd,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,6CAAiD,AACzC,oCAAyC,CACpD,AACD,+BACI,yBAA2B,AAC3B,WAAY,AACZ,yCAA6C,AAC7C,eAAgB,AAChB,kBAAmB,AACnB,gBAAiB,AACjB,UAAa,CAChB,AACD,wBACI,WAAa,AACb,YAAa,AACb,eAAgB,AAChB,eAAkB,CACrB,AACD,4DAEI,WAAa,AACb,qBAAsB,AACtB,cAAgB,CACnB,AACD,6BACI,aAAe,CAClB,AAKD,uBACE,WAAY,AACZ,YAAa,AACb,cAAgB,CACjB,AACD,uBACE,YAAa,AACb,UAAW,AACX,iBAAkB,AAClB,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ,AACD,qBACE,YAAa,AACb,UAAW,AACX,sBAAwB,AACxB,gCAAiC,AACzB,wBAAyB,AACjC,SAAW,CACZ","file":"Modal.vue","sourcesContent":["\n.modal[data-v-330662f6] {\n    position: fixed;\n    /* Nad paskiem górnym (.app-header, z-index 20) i mobilnym menu (99/100),\n       ale pod popupami doklejanymi do body (Syncfusion 1000, datepicker 2001). */\n    z-index: 110;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n    overflow: auto;\n    display: block;\n    background-color: rgba(0,0,0,0.4);\n}\n.flex-container[data-v-330662f6] {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n\n/* margin: auto zamiast align-items/justify-content: center — modal wyższy od\n   ekranu zaczyna się od góry i da się go przewinąć do nagłówka z krzyżykiem\n   (przy centrowaniu flexem jego górna część wystawała poza ekran). */\n.modal-content[data-v-330662f6] {\n    margin: auto;\n    background-color: #fefefe;\n    border: unset;\n    width: auto;\n    z-index: 1000;\n    border-radius: 5px;\n    -webkit-box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n            box-shadow: 0px 4px 10px rgba(0,0,0,0.2);\n}\n.modal-header[data-v-330662f6] {\n    background-color:  #34758E;\n    width: 100%;\n    font-family: \"SourceSansProBold\", sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 600;\n    color: white;\n}\n.close[data-v-330662f6] {\n    color: white;\n    float: right;\n    font-size: 28px;\n    font-weight: bold;\n}\n.close[data-v-330662f6]:hover,\n.close[data-v-330662f6]:focus {\n    color: black;\n    text-decoration: none;\n    cursor: pointer;\n}\n.widthClass[data-v-330662f6] {\n    max-width: 30%;\n}\n.modal-slot[data-v-330662f6] {\n    /* margin-right: 10px;\n    margin-left: 10px; */\n}\n#mdiv[data-v-330662f6] {\n  width: 25px;\n  height: 25px;\n  cursor: pointer;\n}\n.mdiv[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  margin-left: 12px;\n  background-color: white;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n  Z-index: 1;\n}\n.md[data-v-330662f6] {\n  height: 25px;\n  width: 2px;\n  background-color: white;\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n  Z-index: 2;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showDialog)?_c('div',{staticClass:"modal flex-container"},[_c('div',{staticClass:"modal-content vertical",style:(_vm.style)},[_c('div',{staticClass:"modal-header"},[(_vm.title != undefined)?_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title != null ? _vm.title : '')+" ")]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"mdiv"},on:{"click":function($event){return _vm.$emit('close')}}},[_vm._m(0)])]),_vm._v(" "),_c('div',{staticClass:"modal-slot"},[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mdiv"},[_c('div',{staticClass:"md"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1559), __esModule: true };

/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 1559:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1560);
module.exports = __webpack_require__(105).Object.assign;


/***/ }),

/***/ 1560:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(183);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1561) });


/***/ }),

/***/ 1561:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(154);
var getKeys = __webpack_require__(955);
var gOPS = __webpack_require__(1558);
var pIE = __webpack_require__(1555);
var toObject = __webpack_require__(954);
var IObject = __webpack_require__(959);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(442)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ 1572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(1557);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),

/***/ 1862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Modal_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue__ = __webpack_require__(122);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var context = null;

// Komórka z checkboxem dla pola typu alarmu. Grid Syncfusion wstrzykuje wiersz jako `data`
// (kopię), więc stan zawsze czytamy i zmieniamy przez widok (context), a nie lokalnie.
// Klasa faq-checkbox pozwala rowSelected odróżnić klik w checkbox od kliku w wiersz.
function checkboxTemplate(name, field) {
  return function () {
    return {
      template: __WEBPACK_IMPORTED_MODULE_7_vue__["default"].component(name, {
        template: '<label class="faq-checkbox" :title="hint" @click.stop>\n            <input type="checkbox" :checked="data[field]" :disabled="disabled" @change="changed">\n          </label>',
        data: function data() {
          return {
            data: {},
            field: field
          };
        },
        computed: {
          // Push prowadzi do listy alarmów w aplikacji, a ta pokazuje tylko typy z "send to mobile".
          disabled: function disabled() {
            return field === 'sendPush' && !this.data.sendToMobile;
          },
          hint: function hint() {
            return this.disabled ? context.$t('PushRequiresSendToMobile') : '';
          }
        },
        methods: {
          changed: function changed(event) {
            context.updateFlag(this.data.id, field, event.target.checked);
          }
        }
      })
    };
  };
}

/* harmony default export */ __webpack_exports__["b"] = ({
  props: {},
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_5__components_Modal_vue__["a" /* default */]
  },
  provide: {
    grid: [__WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_4__syncfusion_ej2_vue_grids__["b" /* CommandColumn */]]
  },
  data: function data() {
    return {
      selectedRow: null,
      saveError: null,
      questions: [],
      selectedQuestion: null,

      toolbar: ['Search'],
      filterOptions: {
        type: 'Menu'
      },
      wrapSettings: { wrapMode: 'Content' },
      selectionOptions: { type: 'Single' },
      customAttributes: { class: 'customcss' },
      groupOptions: { columns: ['priorityText'] },
      mobileTemplate: checkboxTemplate('faqSendToMobileTemplate', 'sendToMobile'),
      pushTemplate: checkboxTemplate('faqSendPushTemplate', 'sendPush')
    };
  },

  methods: {
    getData: function getData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.dispatch('set_loading', true);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__api__["_1" /* getAllAlarmTypesFaq */])();

              case 3:
                _this.questions = _context.sent;

                _this.questions.forEach(function (el) {
                  el.description = _this.$t(el.description);
                });
                _this.questions.forEach(function (el) {
                  el.priorityText = [_this.$t('HIGH'), _this.$t('MID'), _this.$t('LOW')][el.priority - 1];
                });
                _this.questions = _this.questions.sort(function (a, b) {
                  return a.priority - b.priority;
                });
                _this.$store.dispatch('set_loading', false);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    // rowClick(index) {
    //     if(this.selectedRow !== index) {
    //         this.selectedRow = index;
    //     } else {
    //         this.selectedRow = null;
    //     }
    // },
    rowClass: function rowClass(index) {
      return this.selectedRow === index ? 'selected py-4' : '';
    },

    toolbarClick: function toolbarClick(args) {
      switch (args.item.id) {}
    },
    dataBound: function dataBound() {
      this.$refs.grid.autoFitColumns();
    },
    rowSelected: function rowSelected(row) {
      if (!row.target || !row.target.closest('.faq-checkbox')) {
        this.selectedRow = { rowindex: row.rowIndex, dataId: row.data.id };
      } else {
        this.$refs.grid.clearSelection();
      }
    },
    rowDeselected: function rowDeselected(row) {
      this.selectedRow = null;
      // this.selectedRow = row.
    },
    closeModal: function closeModal() {
      this.selectedRow = null;
      this.$refs.grid.clearSelection();
    },

    // Zmiana od razu w wierszu, a przy błędzie zapisu powrót do poprzedniego stanu.
    // Wyłączenie "send to mobile" wyłącza też push (tak samo robi API).
    updateFlag: function updateFlag(id, field, value) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var row, previous;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                row = _this2.questions.find(function (x) {
                  return x.id == id;
                });
                previous = { sendToMobile: row.sendToMobile, sendPush: row.sendPush };


                row[field] = value;
                if (field === 'sendToMobile' && !value) row.sendPush = false;
                _this2.refreshRow(row);

                _context2.prev = 5;

                if (!(field === 'sendToMobile')) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_6__api__["_125" /* updateSendToMobileStatus */])(id, value);

              case 9:
                _context2.next = 13;
                break;

              case 11:
                _context2.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_6__api__["_124" /* updateSendPushStatus */])(id, value);

              case 13:
                _this2.saveError = null;
                _context2.next = 21;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](5);

                __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(row, previous);
                _this2.refreshRow(row);
                _this2.saveError = _this2.$t('AlarmTypeUpdateFailed');

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 16]]);
      }))();
    },

    // Szablony komórek dostają kopię wiersza - bez tego checkbox push nie zauważyłby
    // wyłączenia "send to mobile" w sąsiedniej kolumnie.
    refreshRow: function refreshRow(row) {
      this.$refs.grid.setRowData(row.id, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, row));
    }
  },
  mounted: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              this.getData();

              context = this;

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
});

/***/ }),

/***/ 2183:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2184);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("7bc33c78", content, true, {});

/***/ }),

/***/ 2184:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".table[data-v-ebbd7d22]{border-top:none;border-left:none;border-right:none}.table tbody[data-v-ebbd7d22]{border-left:1px solid #a3d4e0;border-right:1px solid #a3d4e0}.e-grid .e-headercell.customcss[data-v-ebbd7d22]{padding:0 5px}.e-grid .e-headercell .e-headercelldiv[data-v-ebbd7d22]{padding-right:5px}.e-gridchkbox.customcss .e-checkbox-wrapper[data-v-ebbd7d22]{vertical-align:middle}.faq-save-error[data-v-ebbd7d22]{margin-bottom:8px;padding:8px 12px;border-radius:8px;background-color:var(--danger-hover-bg);color:var(--danger)}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Faq.vue"],"names":[],"mappings":"AACA,wBACI,gBAAiB,AACjB,iBAAkB,AAClB,iBAAmB,CACtB,AACD,8BACI,8BAA+B,AAC/B,8BAAgC,CACnC,AACD,iDACI,aAAoB,CACvB,AACD,wDACI,iBAAkB,CACrB,AACD,6DACI,qBAAuB,CAC1B,AACD,iCACI,kBAAmB,AACnB,iBAAkB,AAClB,kBAAmB,AACnB,wCAAyC,AACzC,mBAAqB,CACxB","file":"Faq.vue","sourcesContent":["\n.table[data-v-ebbd7d22] {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n}\n.table tbody[data-v-ebbd7d22]{\n    border-left: 1px solid #A3D4E0;\n    border-right: 1px solid #A3D4E0;\n}\n.e-grid .e-headercell.customcss[data-v-ebbd7d22]{\n    padding:0 5px 0 5px;\n}\n.e-grid .e-headercell .e-headercelldiv[data-v-ebbd7d22]{\n    padding-right:5px;\n}\n.e-gridchkbox.customcss .e-checkbox-wrapper[data-v-ebbd7d22]{\n    vertical-align: middle;\n}\n.faq-save-error[data-v-ebbd7d22] {\n    margin-bottom: 8px;\n    padding: 8px 12px;\n    border-radius: 8px;\n    background-color: var(--danger-hover-bg);\n    color: var(--danger);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2185:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2186);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("3d8fa27e", content, true, {});

/***/ }),

/***/ 2186:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, ".faq-checkbox{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0;padding:4px;cursor:pointer}.faq-checkbox input{width:18px;height:18px;margin:0;accent-color:var(--accent);cursor:pointer}.faq-checkbox input:disabled{cursor:not-allowed;opacity:.45}", "", {"version":3,"sources":["/Users/sleepingwarrior/BioControl/crfi-monitoring/UI/crfi_monitoring/src/views/Faq.vue"],"names":[],"mappings":"AAwNA,cACI,2BAA4B,AAC5B,2BAA4B,AAC5B,oBAAqB,AACrB,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,SAAU,AACV,YAAa,AACb,cAAgB,CACnB,AACD,oBACI,WAAY,AACZ,YAAa,AACb,SAAU,AACV,2BAA4B,AAC5B,cAAgB,CACnB,AACD,6BACI,mBAAoB,AACpB,WAAc,CACjB","file":"Faq.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* Poza scoped: komórki gridu to osobne komponenty szablonów. */\n.faq-checkbox {\n    display: -webkit-inline-box;\n    display: -ms-inline-flexbox;\n    display: inline-flex;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 0;\n    padding: 4px;\n    cursor: pointer;\n}\n.faq-checkbox input {\n    width: 18px;\n    height: 18px;\n    margin: 0;\n    accent-color: var(--accent);\n    cursor: pointer;\n}\n.faq-checkbox input:disabled {\n    cursor: not-allowed;\n    opacity: 0.45;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-container"},[_c('modal',{attrs:{"showDialog":_vm.selectedRow != null,"maxWidth":'50vw',"title":_vm.selectedRow!= null ? _vm.questions.find(function (x) { return x.id == _vm.selectedRow.dataId; }).description : null},on:{"close":_vm.closeModal}},[_c('div',{staticClass:"m-4"},[_c('div',{staticClass:"mb-1",staticStyle:{"font-weight":"bold"}},[_vm._v("\n         "+_vm._s(_vm.selectedRow != null ? _vm.questions.find(function (x) { return x.id == _vm.selectedRow.dataId; }).description : null)+"\n      ")]),_vm._v(" "),_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v("\n        "+_vm._s(_vm.selectedRow != null ? _vm.questions.find(function (x) { return x.id == _vm.selectedRow.dataId; }).conditions : null)+"\n      ")])])]),_vm._v(" "),(_vm.saveError)?_c('div',{staticClass:"faq-save-error",attrs:{"role":"alert"}},[_vm._v(_vm._s(_vm.saveError))]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","height":"100%","overflow-x":"auto"}},[_c('div',{staticClass:"max-grid"},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"rowSelected":_vm.rowSelected,"rowDeselected":_vm.rowDeselected,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.questions,"allowPaging":false,"allowFiltering":false,"allowSorting":true,"allowMultiSorting":true,"showBusyIndicator":true,"allowGrouping":true,"groupSettings":_vm.groupOptions}},[_c('e-columns',[_c('e-column',{attrs:{"field":"id","isPrimaryKey":true,"headerText":_vm.$t('NUMBER'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),_c('e-column',{attrs:{"field":"description","headerText":_vm.$t('DESCRIPTION'),"textAlign":"Left","customAttributes":_vm.customAttributes}}),_vm._v(" "),(_vm.$store.getters.isAdmin)?_c('e-column',{attrs:{"field":"sendToMobile","headerText":_vm.$t('SEND_TO_MOBILE'),"template":_vm.mobileTemplate,"allowFiltering":false,"allowSorting":false,"textAlign":"Center"}}):_vm._e(),_vm._v(" "),(_vm.$store.getters.isAdmin)?_c('e-column',{attrs:{"field":"sendPush","headerText":_vm.$t('SEND_PUSH'),"template":_vm.pushTemplate,"allowFiltering":false,"allowSorting":false,"textAlign":"Center"}}):_vm._e(),_vm._v(" "),_c('e-column',{attrs:{"visible":false,"field":"priorityText","headerText":_vm.$t('PRIORITY'),"textAlign":"Left","customAttributes":_vm.customAttributes}})],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/29.0b1f51e41aee3aca9e2c.js